/**
 * https://tdanemar.wordpress.com/2010/08/24/jquery-serialize-method-and-checkboxes/
 *
 * Replace checkbox values with true/false if checkboxesAsBools: true is passed in options.
 *
 * The default behaviour with no options passed in (or checkboxesAsBools set to false)
 * is just like the standard jQuery serialize method.
 */

(function ($) {

  $.fn.serialize = function (options) {
    return $.param(this.serializeArray(options));
  };

  $.fn.serializeArray = function (options) {
    var o = $.extend({
      checkboxesAsBools: false
    }, options || {});

    var rselectTextarea = /select|textarea/i;
    var rinput = /text|email|tel|number|hidden|password|search/i;

    return this.map(function () {
      return this.elements ? $.makeArray(this.elements) : this;
    })
      .filter(function () {
        return this.name && !this.disabled &&
          (this.checked
          || (o.checkboxesAsBools && this.type === 'checkbox')
          || rselectTextarea.test(this.nodeName)
          || rinput.test(this.type));
      })
      .map(function (i, elem) {
        var val = $(this).val();
        return val == null ?
          null :
          $.isArray(val) ?
            $.map(val, function (val, i) {
              return { name: elem.name, value: val };
            }) :
            {
              name: elem.name,
              value: (o.checkboxesAsBools && this.type === 'checkbox') ? //moar ternaries!
                (this.checked ? 'true' : 'false') :
                val
            };
      }).get();
  };

})(jQuery);